export default __webpack_public_path__ + "static/media/ic-show-password.ed37f3e2.svg";